import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useScroll, useSpring } from 'framer-motion';
import { BookOpen, ArrowRight } from 'lucide-react';
export function LuxuryStickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-[var(--accent)] origin-left z-50 opacity-80" style={{
      scaleX
    }} data-id="element-203" />

      <AnimatePresence data-id="element-204">
        {isVisible && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pt-2 pointer-events-none flex justify-center" data-id="element-205">
            <div className="pointer-events-auto bg-[#1a0b0e]/95 backdrop-blur-md border border-[var(--accent)]/30 rounded-full shadow-2xl py-2 px-4 md:py-3 md:px-6 flex items-center gap-4 md:gap-8 max-w-lg w-full justify-between" data-id="element-206">
              <div className="hidden md:flex flex-col" data-id="element-207">
                <span className="text-[10px] text-[var(--accent)] uppercase tracking-widest font-bold" data-id="element-208">
                  40 Días para volver a respirar
                </span>
                <span className="text-sm text-[var(--text-heading)] font-serif italic" data-id="element-209">
                  Cuando Dios es lo único que te queda
                </span>
              </div>

              <div className="flex items-center gap-4 ml-auto md:ml-0 w-full md:w-auto justify-between md:justify-end" data-id="element-210">
                <div className="flex flex-col items-end" data-id="element-211">
                  <span className="text-[10px] text-[var(--text-muted)] line-through" data-id="element-212">
                    $19
                  </span>
                  <div className="flex items-center gap-1.5" data-id="element-213">
                    <span className="text-xs bg-[var(--red-emphasis)]/20 text-[var(--red-emphasis)] font-bold px-1.5 py-0.5 rounded uppercase tracking-wide" data-id="element-214">
                      OFERTA
                    </span>
                    <span className="text-lg font-serif font-bold text-[var(--accent)]" data-id="element-215">
                      $6.39{' '}
                      <span className="text-xs font-sans font-normal text-[var(--text-muted)]" data-id="element-216">
                        USD
                      </span>
                    </span>
                  </div>
                </div>

                <button onClick={() => {
              if (typeof (window as any).fbq === 'function') {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Cuando Dios es lo único que te queda',
                  value: 6.39,
                  currency: 'USD'
                });
              }
              window.open('https://www.simplementemejor.com/cart/51706800537880:1', '_blank');
            }} className="bg-gradient-to-r from-[var(--accent)] to-[#dfc06a] hover:from-[var(--accent-hover)] hover:to-[#e8cc72] text-[#110608] px-6 py-2.5 rounded-full font-extrabold text-xs uppercase tracking-wide transition-all shadow-[0_0_20px_rgba(201,168,76,0.4)] flex items-center gap-2" data-id="element-217">
                  <BookOpen className="w-3 h-3" data-id="element-218" />
                  <span data-id="element-219">Empezar por $6.39</span>
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}